import React from 'react'

import Icon from 'app/components/icons/icon/icon.component'
import PlayArrowSVG from 'app/components/icons/play-arrow-icon/play-arrow-icon.svg'

type PlayArrowIconProps = {
  width?: number | string
  height?: number | string
  className?: string
}

const PlayArrowIcon = ({
  width = 'auto',
  height = 'auto',
  className,
}: PlayArrowIconProps) => (
  <Icon
    className={className}
    src={PlayArrowSVG}
    alt="Play Arrow Icon"
    width={width}
    height={height}
    aria-hidden="true"
  />
)

export default PlayArrowIcon
